import type { TOC } from '@ember/component/template-only'
import type BookLibrarySharesNewController from 'teacher-ui-client/subscription-type/book-library/shares/new/controller'
import type BookLibrarySharesNewRoute from 'teacher-ui-client/subscription-type/book-library/shares/new/route'
import { or } from 'ember-truth-helpers'
import { FidgetLoadingIndicatorComponent } from '@blakeelearning/fidget/components/fidget/loading-indicator'
import { BookLibrarySharesNew } from 'teacher-ui-client/components/page/book-library/shares/new'
import { and } from 'ember-truth-helpers'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<BookLibrarySharesNewRoute>
    controller: BookLibrarySharesNewController
  }
}
export const BookLibrarySharesNewPage: TOC<Signature> = <template>
  {{#if (or @model.loadCollection.isRunning @model.loadStudents.isRunning)}}
    <FidgetLoadingIndicatorComponent @show={{true}} @centered={{true}} @overlay={{false}} />
  {{else if (and @model.loadCollection.isSuccessful @model.loadStudents.isSuccessful)}}
    {{! Nested if to please ts linter, using and modifier isn't recognised
  and these values should be defined due to the above isSuccessful checks }}
    {{#if @model.loadCollection.value}}
      {{#if @model.loadStudents.value}}
        <BookLibrarySharesNew
          @subscriptionType={{@model.subscriptionType}}
          @collection={{@model.loadCollection.value}}
          @students={{@model.loadStudents.value}}
          @sortingConfig={{@controller.sortingConfig}}
          @paginationConfig={{@controller.paginationConfig}}
          @selectedStudentIds={{@controller.selectedStudentIds}}
          @searchString={{@controller.search}}
          @gradePosition={{@controller.grade}}
          @schoolClassId={{@controller.schoolClass}}
          @onSortClick={{@controller.updateSorts}}
          @onSelectClick={{@controller.updateSelected}}
          @onSearchInput={{@controller.updateSearch}}
          @onGradePositionSelect={{@controller.updateGrade}}
          @onSchoolClassIdSelect={{@controller.updateSchoolClass}}
        />
      {{/if}}
    {{/if}}
  {{/if}}
</template>

export default RouteTemplate(BookLibrarySharesNewPage)
